import { createFileRoute } from '@tanstack/react-router';
import { sourcesQuery } from '@/features/sources/api';
import { SourcesPage } from '@/features/sources/pages/SourcesPage';

export const Route = createFileRoute('/_authed/ops/sources/')({
  staticData: { help: 'sources' },
  loader: ({ context: { queryClient } }) => {
    void queryClient.prefetchQuery(sourcesQuery());
  },
  component: SourcesPage,
});
